/**
 * Google Maps style array — dark theme tuned to match the dispatcher's
 * navy / bone palette. Designed to keep our red TX pins visually
 * dominant against the muted tile background.
 *
 * Reference docs: https://developers.google.com/maps/documentation/javascript/style-reference
 *
 * Color choices:
 *   - Land geometry:     #0D1726 (slightly lighter than --navy-900)
 *   - Roads:             #1B2A40 → #243956 (graduated by importance)
 *   - Water:             #050A12 (near-black for high contrast)
 *   - Labels:            muted bone with darker stroke for legibility
 *   - POI / Transit:     hidden — clutters the operational view
 */
export const DARK_MAP_STYLE: google.maps.MapTypeStyle[] = [
  // Base palette
  { elementType: "geometry",        stylers: [{ color: "#0D1726" }] },
  { elementType: "labels.text.fill",   stylers: [{ color: "#7F8B9C" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#050A12" }] },

  // Hide things we don't want — keeps the map readable when zoomed out.
  { featureType: "poi",             stylers: [{ visibility: "off" }] },
  { featureType: "poi.business",    stylers: [{ visibility: "off" }] },
  { featureType: "transit",         stylers: [{ visibility: "off" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#0F1F2C" }] },
  { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#5A7A60" }] },

  // Administrative boundaries — subtle but visible
  { featureType: "administrative.country", elementType: "geometry.stroke",
    stylers: [{ color: "#3B5072" }] },
  { featureType: "administrative.province", elementType: "geometry.stroke",
    stylers: [{ color: "#2A3F5E" }] },
  { featureType: "administrative.locality", elementType: "labels.text.fill",
    stylers: [{ color: "#A8B2C2" }] },
  { featureType: "administrative.neighborhood", elementType: "labels.text.fill",
    stylers: [{ color: "#6B7686" }] },

  // Roads
  { featureType: "road",            elementType: "geometry",
    stylers: [{ color: "#1B2A40" }] },
  { featureType: "road",            elementType: "geometry.stroke",
    stylers: [{ color: "#0A1424" }] },
  { featureType: "road",            elementType: "labels.text.fill",
    stylers: [{ color: "#9098A6" }] },
  { featureType: "road.highway",    elementType: "geometry",
    stylers: [{ color: "#243956" }] },
  { featureType: "road.highway",    elementType: "geometry.stroke",
    stylers: [{ color: "#0A1424" }] },
  { featureType: "road.highway",    elementType: "labels.text.fill",
    stylers: [{ color: "#C7CDD8" }] },
  { featureType: "road.arterial",   elementType: "geometry",
    stylers: [{ color: "#1F2F47" }] },
  { featureType: "road.local",      elementType: "labels", stylers: [{ visibility: "off" }] },

  // Water
  { featureType: "water",           elementType: "geometry",
    stylers: [{ color: "#050A12" }] },
  { featureType: "water",           elementType: "labels.text.fill",
    stylers: [{ color: "#3B5072" }] },
];
